import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      brand: 'Tu Iglesia App',
      product_name: 'BOMM',
      product_subtitle: 'Back Office de Mantenimiento y Monitoreo',
      tagline: 'Tu aliado en el Ministerio de Cristo',
      // nav
      nav_overview: 'Resumen',
      nav_services: 'Servicios',
      nav_logs: 'Logs',
      nav_incidents: 'Incidentes',
      nav_maintenance: 'Mantenimientos',
      nav_deployments: 'Despliegues',
      nav_database: 'Base de Datos',
      nav_backups: 'Respaldos',
      nav_alerts: 'Alertas',
      nav_users: 'Usuarios',
      nav_settings: 'Ajustes',
      nav_audit: 'Auditoría',
      // common
      sign_in: 'Iniciar sesión',
      sign_out: 'Cerrar sesión',
      email: 'Correo',
      password: 'Contraseña',
      remember_me: 'Recordarme',
      welcome_back: 'Bienvenido de nuevo',
      login_subtitle: 'Centro de operaciones para el equipo de tecnología',
      sample_credentials: 'Credenciales de ejemplo',
      // dashboard
      kpi_services: 'Servicios',
      kpi_uptime_24h: 'Uptime 24h',
      kpi_latency: 'Latencia 1h',
      kpi_active_alerts: 'Alertas activas',
      kpi_open_incidents: 'Incidentes abiertos',
      services_status: 'Estado de servicios',
      recent_alerts: 'Alertas recientes',
      upcoming_maintenance: 'Mantenimientos próximos',
      recent_deployments: 'Despliegues recientes',
      latency_over_time: 'Latencia en el tiempo',
      checks_distribution: 'Distribución de checks',
      // status
      status_up: 'Operativo',
      status_down: 'Caído',
      status_warn: 'Advertencia',
      status_maintenance: 'Mantenimiento',
      status_paused: 'Pausado',
      status_unknown: 'Sin datos',
      // services
      service_new: 'Nuevo servicio',
      service_name: 'Nombre',
      service_type: 'Tipo',
      service_url: 'URL de health check',
      service_interval: 'Intervalo (s)',
      service_expected: 'Estado esperado',
      service_timeout: 'Timeout (s)',
      service_environment: 'Entorno',
      service_version: 'Versión',
      service_description: 'Descripción',
      service_check_now: 'Verificar ahora',
      service_pause: 'Pausar',
      service_resume: 'Reanudar',
      service_maintenance: 'Modo mantenimiento',
      service_history: 'Historial de checks',
      service_uptime: 'Uptime',
      service_save: 'Guardar',
      service_cancel: 'Cancelar',
      service_delete: 'Eliminar',
      // logs
      logs_title: 'Logs centralizados',
      logs_search_placeholder: 'Buscar mensaje...',
      logs_level: 'Nivel',
      logs_service: 'Servicio',
      logs_tail: 'Tail en vivo',
      logs_seed: 'Generar logs demo',
      logs_all_levels: 'Todos los niveles',
      logs_all_services: 'Todos los servicios',
      // incidents
      incidents_title: 'Incidentes',
      incidents_new: 'Nuevo incidente',
      incidents_open: 'Abiertos',
      incidents_inv: 'Investigando',
      incidents_mit: 'Mitigando',
      incidents_resolved: 'Resueltos',
      incidents_closed: 'Cerrados',
      incidents_severity: 'Severidad',
      incidents_assignee: 'Responsable',
      incidents_comment: 'Comentar',
      // maintenance
      maintenance_title: 'Mantenimientos',
      maintenance_new: 'Programar mantenimiento',
      maintenance_starts: 'Inicio',
      maintenance_ends: 'Fin',
      maintenance_services: 'Servicios afectados',
      // deployments
      deployments_title: 'Despliegues',
      deployments_new: 'Registrar despliegue',
      // database
      database_title: 'Monitor de Base de Datos',
      database_collections: 'Colecciones',
      database_documents: 'Documentos',
      database_size: 'Tamaño',
      database_indexes: 'Índices',
      database_objects: 'Objetos totales',
      database_explorer: 'Explorador (solo lectura)',
      // backups
      backups_title: 'Respaldos',
      backups_run_now: 'Ejecutar respaldo',
      backups_schedule: 'Programación',
      backups_retention: 'Retención (días)',
      // alerts
      alerts_title: 'Alertas y Reglas',
      alerts_active: 'Alertas activas',
      alerts_rules: 'Reglas',
      alerts_ack: 'Reconocer',
      alerts_new_rule: 'Nueva regla',
      // users
      users_title: 'Usuarios y Roles',
      users_new: 'Nuevo usuario',
      role_admin: 'Administrador',
      role_tech: 'Técnico',
      role_viewer: 'Viewer',
      // settings
      settings_title: 'Ajustes',
      settings_language: 'Idioma',
      settings_global_maint: 'Modo mantenimiento global',
      settings_global_maint_msg: 'Mensaje de mantenimiento',
      // audit
      audit_title: 'Auditoría',
      audit_actor: 'Actor',
      audit_action: 'Acción',
      audit_resource: 'Recurso',
      audit_when: 'Cuándo',
      // common verbs
      save: 'Guardar',
      cancel: 'Cancelar',
      create: 'Crear',
      update: 'Actualizar',
      delete: 'Eliminar',
      close: 'Cerrar',
      yes: 'Sí',
      no: 'No',
      search: 'Buscar',
      refresh: 'Actualizar',
      view_all: 'Ver todo',
      no_data: 'Sin datos',
      loading: 'Cargando...',
      success: 'Éxito',
      error: 'Error',
      acknowledged: 'Reconocida',
      details: 'Detalles',
      // grupos de navegación
      group_bom: 'BOMM Interno',
      group_ops: 'Tu Iglesia App',
      nav_app_monitor: 'Monitor de la App',
      nav_app_support: 'Soporte',
      nav_app_tickets: 'Tickets',
      nav_ai_agent: 'Agente IA',
      nav_campaigns: 'Despliegues Ministeriales',
      nav_whatsapp: 'WhatsApp',
      nav_app_finance: 'Finanzas / Caura',
      nav_app_flags: 'Flags y Mantenimiento',
      nav_app_webhooks: 'Webhooks',
      // ops monitor
      ops_connected: 'Conectado a la App',
      ops_disconnected: 'Sin conexión con la App',
      ops_base_url: 'Endpoint Ops',
      ops_dependencies: 'Dependencias',
      ops_users_total: 'Usuarios',
      ops_churches: 'Iglesias',
      ops_contributions: 'Aportes',
      ops_sessions: 'Sesiones activas',
      ops_chat: 'Mensajes de chat',
      ops_pending_approval: 'Por aprobar',
      ops_errors_24h: 'Errores 5xx (24h)',
      ops_reports_pending: 'Reportes pendientes',
      ops_requests_trend: 'Tendencia de tráfico (req/5xx/latencia)',
      ops_recent_errors: 'Errores recientes',
      ops_lockouts: 'Bloqueos de seguridad',
      ops_no_lockouts: 'Sin cuentas ni IPs bloqueadas',
      // soporte
      ops_search_user: 'Buscar usuario por nombre, correo o handle...',
      ops_user_sheet: 'Ficha de usuario',
      ops_account: 'Cuenta',
      ops_church: 'Iglesia',
      ops_lockout_state: 'Estado de bloqueo',
      ops_recent_contributions: 'Aportes recientes',
      ops_login_attempts: 'Intentos de acceso',
      ops_remediation: 'Remediación',
      ops_unlock: 'Desbloquear',
      ops_revoke: 'Revocar sesiones',
      ops_pwd_reset: 'Reset de contraseña',
      ops_locked: 'Bloqueado',
      ops_not_locked: 'Sin bloqueo',
      ops_masked_hint: 'Correo enmascarado (sin permiso PII)',
      // flags
      ops_maintenance_mode: 'Modo mantenimiento de la App',
      ops_maintenance_on: 'La App está en mantenimiento (responde 503)',
      ops_maintenance_off: 'La App está operativa',
      ops_flags_title: 'Feature Flags',
      ops_new_flag: 'Nuevo flag',
      ops_flag_key: 'Clave',
      ops_flag_value: 'Valor (JSON)',
      ops_flag_desc: 'Descripción',
      ops_thresholds: 'Umbrales de alerta',
      ops_error_rate: 'Tasa de errores 5xx',
      ops_payment_backlog: 'Backlog de pagos',
      ops_window_min: 'Ventana (min)',
      ops_max_count: 'Máximo',
      ops_stuck_min: 'Atascado (min)',
      ops_cooldown_min: 'Enfriamiento (min)',
      ops_enabled: 'Activo',
      ops_current: 'Actual',
      ops_breaching: 'En umbral',
      // finanzas
      ops_caura_webhooks: 'Webhooks de CauraPay',
      ops_outcome: 'Resultado',
      ops_reprocess: 'Reprocesar',
      ops_reverify: 'Reverificar aporte',
      ops_contribution_id: 'ID del aporte',
      // webhooks
      ops_webhooks_title: 'Suscripciones de Webhooks',
      ops_new_webhook: 'Nuevo webhook',
      ops_webhook_url: 'URL destino',
      ops_webhook_events: 'Eventos',
      ops_deliveries: 'Entregas recientes',
      ops_test: 'Probar',
      ops_secret_once: 'Guarda este secreto, solo se muestra una vez:',
      // feed en vivo
      feed_title: 'Feed en vivo',
      feed_subtitle: 'Eventos push de la App (errores, bloqueos, pagos atascados)',
      feed_empty: 'Sin eventos todavía. Registra un webhook apuntando a tu /api/ops-hook para recibir eventos en tiempo real.',
      feed_event: 'Evento',
      // iglesias
      nav_app_churches: 'Iglesias',
      ops_lookup_church: 'Buscar ficha por ID de iglesia...',
      ops_church_id: 'ID de iglesia',
      ops_known_churches: 'Iglesias conocidas',
      ops_view_church: 'Ver ficha',
      ops_members: 'Miembros',
      ops_subscription: 'Suscripción',
      ops_balance: 'Balance',
      ops_caurapay: 'CauraPay',
      ops_dispersion: 'Dispersión configurada',
      ops_plan: 'Plan',
      ops_sub_status: 'Estado',
      ops_expires: 'Expira',
      ops_provisioned: 'Provisionado',
      ops_project_id: 'Project ID',
      ops_code: 'Código',
      ops_api_key: 'API key',
      ops_discover_hint: 'Las iglesias se agregan automáticamente al consultar fichas de usuario en Soporte.',
      confirm: 'Confirmar',
      not_available: 'No disponible',
    },
  },
  en: {
    translation: {
      brand: 'Tu Iglesia App',
      product_name: 'BOMM',
      product_subtitle: 'Back Office Maintenance & Monitor',
      tagline: 'Your ally in the Ministry of Christ',
      nav_overview: 'Overview',
      nav_services: 'Services',
      nav_logs: 'Logs',
      nav_incidents: 'Incidents',
      nav_maintenance: 'Maintenance',
      nav_deployments: 'Deployments',
      nav_database: 'Database',
      nav_backups: 'Backups',
      nav_alerts: 'Alerts',
      nav_users: 'Users',
      nav_settings: 'Settings',
      nav_audit: 'Audit',
      sign_in: 'Sign in',
      sign_out: 'Sign out',
      email: 'Email',
      password: 'Password',
      remember_me: 'Remember me',
      welcome_back: 'Welcome back',
      login_subtitle: 'Operations center for the technology team',
      sample_credentials: 'Sample credentials',
      kpi_services: 'Services',
      kpi_uptime_24h: 'Uptime 24h',
      kpi_latency: 'Latency 1h',
      kpi_active_alerts: 'Active alerts',
      kpi_open_incidents: 'Open incidents',
      services_status: 'Services status',
      recent_alerts: 'Recent alerts',
      upcoming_maintenance: 'Upcoming maintenance',
      recent_deployments: 'Recent deployments',
      latency_over_time: 'Latency over time',
      checks_distribution: 'Checks distribution',
      status_up: 'Operational',
      status_down: 'Down',
      status_warn: 'Warning',
      status_maintenance: 'Maintenance',
      status_paused: 'Paused',
      status_unknown: 'Unknown',
      service_new: 'New service',
      service_name: 'Name',
      service_type: 'Type',
      service_url: 'Health check URL',
      service_interval: 'Interval (s)',
      service_expected: 'Expected status',
      service_timeout: 'Timeout (s)',
      service_environment: 'Environment',
      service_version: 'Version',
      service_description: 'Description',
      service_check_now: 'Check now',
      service_pause: 'Pause',
      service_resume: 'Resume',
      service_maintenance: 'Maintenance mode',
      service_history: 'Check history',
      service_uptime: 'Uptime',
      service_save: 'Save',
      service_cancel: 'Cancel',
      service_delete: 'Delete',
      logs_title: 'Centralized logs',
      logs_search_placeholder: 'Search message...',
      logs_level: 'Level',
      logs_service: 'Service',
      logs_tail: 'Live tail',
      logs_seed: 'Generate demo logs',
      logs_all_levels: 'All levels',
      logs_all_services: 'All services',
      incidents_title: 'Incidents',
      incidents_new: 'New incident',
      incidents_open: 'Open',
      incidents_inv: 'Investigating',
      incidents_mit: 'Mitigating',
      incidents_resolved: 'Resolved',
      incidents_closed: 'Closed',
      incidents_severity: 'Severity',
      incidents_assignee: 'Assignee',
      incidents_comment: 'Comment',
      maintenance_title: 'Maintenance',
      maintenance_new: 'Schedule maintenance',
      maintenance_starts: 'Starts',
      maintenance_ends: 'Ends',
      maintenance_services: 'Affected services',
      deployments_title: 'Deployments',
      deployments_new: 'Register deployment',
      database_title: 'Database Monitor',
      database_collections: 'Collections',
      database_documents: 'Documents',
      database_size: 'Size',
      database_indexes: 'Indexes',
      database_objects: 'Total objects',
      database_explorer: 'Explorer (read-only)',
      backups_title: 'Backups',
      backups_run_now: 'Run backup',
      backups_schedule: 'Schedule',
      backups_retention: 'Retention (days)',
      alerts_title: 'Alerts & Rules',
      alerts_active: 'Active alerts',
      alerts_rules: 'Rules',
      alerts_ack: 'Acknowledge',
      alerts_new_rule: 'New rule',
      users_title: 'Users & Roles',
      users_new: 'New user',
      role_admin: 'Admin',
      role_tech: 'Tech',
      role_viewer: 'Viewer',
      settings_title: 'Settings',
      settings_language: 'Language',
      settings_global_maint: 'Global maintenance mode',
      settings_global_maint_msg: 'Maintenance message',
      audit_title: 'Audit',
      audit_actor: 'Actor',
      audit_action: 'Action',
      audit_resource: 'Resource',
      audit_when: 'When',
      save: 'Save',
      cancel: 'Cancel',
      create: 'Create',
      update: 'Update',
      delete: 'Delete',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
      search: 'Search',
      refresh: 'Refresh',
      view_all: 'View all',
      no_data: 'No data',
      loading: 'Loading...',
      success: 'Success',
      error: 'Error',
      acknowledged: 'Acknowledged',
      details: 'Details',
      // nav groups
      group_bom: 'Internal BOMM',
      group_ops: 'Tu Iglesia App',
      nav_app_monitor: 'App Monitor',
      nav_app_support: 'Support',
      nav_app_tickets: 'Tickets · Suite',
      nav_ai_agent: 'Agente IA',
      nav_campaigns: 'Despliegues Ministeriales',
      nav_whatsapp: 'WhatsApp',
      nav_app_finance: 'Finance / Caura',
      nav_app_flags: 'Flags & Maintenance',
      nav_app_webhooks: 'Webhooks',
      ops_connected: 'Connected to the App',
      ops_disconnected: 'No connection to the App',
      ops_base_url: 'Ops endpoint',
      ops_dependencies: 'Dependencies',
      ops_users_total: 'Users',
      ops_churches: 'Churches',
      ops_contributions: 'Contributions',
      ops_sessions: 'Active sessions',
      ops_chat: 'Chat messages',
      ops_pending_approval: 'Pending approval',
      ops_errors_24h: '5xx errors (24h)',
      ops_reports_pending: 'Pending reports',
      ops_requests_trend: 'Traffic trend (req/5xx/latency)',
      ops_recent_errors: 'Recent errors',
      ops_lockouts: 'Security lockouts',
      ops_no_lockouts: 'No locked accounts or IPs',
      ops_search_user: 'Search user by name, email or handle...',
      ops_user_sheet: 'User record',
      ops_account: 'Account',
      ops_church: 'Church',
      ops_lockout_state: 'Lockout state',
      ops_recent_contributions: 'Recent contributions',
      ops_login_attempts: 'Login attempts',
      ops_remediation: 'Remediation',
      ops_unlock: 'Unlock',
      ops_revoke: 'Revoke sessions',
      ops_pwd_reset: 'Password reset',
      ops_locked: 'Locked',
      ops_not_locked: 'Not locked',
      ops_masked_hint: 'Masked email (no PII permission)',
      ops_maintenance_mode: 'App maintenance mode',
      ops_maintenance_on: 'The App is under maintenance (returns 503)',
      ops_maintenance_off: 'The App is operational',
      ops_flags_title: 'Feature Flags',
      ops_new_flag: 'New flag',
      ops_flag_key: 'Key',
      ops_flag_value: 'Value (JSON)',
      ops_flag_desc: 'Description',
      ops_thresholds: 'Alert thresholds',
      ops_error_rate: '5xx error rate',
      ops_payment_backlog: 'Payment backlog',
      ops_window_min: 'Window (min)',
      ops_max_count: 'Max',
      ops_stuck_min: 'Stuck (min)',
      ops_cooldown_min: 'Cooldown (min)',
      ops_enabled: 'Enabled',
      ops_current: 'Current',
      ops_breaching: 'Breaching',
      ops_caura_webhooks: 'CauraPay webhooks',
      ops_outcome: 'Outcome',
      ops_reprocess: 'Reprocess',
      ops_reverify: 'Reverify contribution',
      ops_contribution_id: 'Contribution ID',
      ops_webhooks_title: 'Webhook subscriptions',
      ops_new_webhook: 'New webhook',
      ops_webhook_url: 'Target URL',
      ops_webhook_events: 'Events',
      ops_deliveries: 'Recent deliveries',
      ops_test: 'Test',
      ops_secret_once: 'Save this secret, it is shown only once:',
      feed_title: 'Live feed',
      feed_subtitle: 'App push events (errors, lockouts, stuck payments)',
      feed_empty: 'No events yet. Register a webhook pointing to your /api/ops-hook to receive real-time events.',
      feed_event: 'Event',
      nav_app_churches: 'Churches',
      ops_lookup_church: 'Look up record by church ID...',
      ops_church_id: 'Church ID',
      ops_known_churches: 'Known churches',
      ops_view_church: 'View record',
      ops_members: 'Members',
      ops_subscription: 'Subscription',
      ops_balance: 'Balance',
      ops_caurapay: 'CauraPay',
      ops_dispersion: 'Dispersion configured',
      ops_plan: 'Plan',
      ops_sub_status: 'Status',
      ops_expires: 'Expires',
      ops_provisioned: 'Provisioned',
      ops_project_id: 'Project ID',
      ops_code: 'Code',
      ops_api_key: 'API key',
      ops_discover_hint: 'Churches are added automatically when you open user records in Support.',
      confirm: 'Confirm',
      not_available: 'Not available',
    },
  },
};

const saved = (typeof window !== 'undefined' && window.localStorage.getItem('lang')) || 'es';

i18n.use(initReactI18next).init({
  resources,
  lng: saved,
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
});

export default i18n;
